import { render, staticRenderFns } from "./camera.component.vue?vue&type=template&id=e43c5450&"
import script from "./camera.component.vue?vue&type=script&lang=js&"
export * from "./camera.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports